import { Component, OnInit } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router } from '@angular/router';
import { shakeAnimation } from 'angular-animations';
import { SearchService } from '@services/search.service';
import { CategoryService } from '@services/category.service';
import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

import * as _ from 'lodash';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass'],
  animations: [
    shakeAnimation({ anchor: 'listbtnbounce', duration: 3000, delay: 3000 })
  ]
})
export class HeaderComponent implements OnInit {
  listbtnbounceTrigger = false;
  totalcategory = 0;
  site: any = {}
  isLogin = false;
  category: any = [];
  searchtxt = "";
  name = "";
  email = "";
  user_id = "";
  user_src: any = {};
  user: any = {};
  component = 'b';
  menu_limit = 0;
  column = [1, 2, 3, 4];
  constructor(public local: LocalStorageService, public session: SessionStorageService, private _categoryService: CategoryService, private _searchService: SearchService, private router: Router, private _global: GlobalService) {
    this.site['id'] = this._global.SITEID;
    this.site['name'] = this._global.SITE_NAME;
    this.user_id = this._global.getRandomUuid();
    if (this._global.isAuthenticated()) {
      this.isLogin = true;
      this.user_id = this._global.getSessionVal('id');
    }
    this.user = {
      id: this.user_id,
      name: 'noname'
    };
    this.name = this._global.getSessionVal('firstName') + "  " + this._global.getSessionVal('lastName');
    this.email = this._global.getSessionVal('email');
    this.user_src = this._global.generateImagePath(this.user, ['member', 'id', 'name', 'm']);
   let category_item = this.local.get(this._global.SESSION_KEY + '_category');
      if (category_item !=null && category_item['category']) {
      this.category = category_item['category'];
      this.totalcategory = category_item['menu_limit'];
      this.menu_limit =category_item['menu_limit'];
    } else {
      this.local.remove(this._global.SESSION_KEY + '_category');
      let pa = {
        component: this.component,
        application: 'category',
        categoryType: 'business'
      };
      this._categoryService.application(pa).subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.category = data["response"];
            this.totalcategory = Object.keys(this.category).length;
            this.menu_limit = Math.round(this.totalcategory / 4);
            let item = {
              category: data["response"],
              totalcategory: this.totalcategory,
              menu_limit: this.menu_limit
            };
            this.local.set(this._global.SESSION_KEY + '_category', item, 20, 'm');
          }
        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    } 
  }
  ngOnInit() {

    if (this._global.isAuthenticated()) {
      this.isLogin = true;
    }
  }
  search() {
    this.router.navigate(['/business'], { queryParams: { name: this.searchtxt } });
  }

  returnZero() {
    return 0
  }
  isObject(value) {
    return typeof value == "object" ? true : false;
  }
  catCondition(row, i) {
    let r = false;
    i++;
    if (row == 1) {
      if (this.menu_limit * 1 >= i) {
        r = true;
      }
    } else if (row == 2) {
      if (i > this.menu_limit && i <= this.menu_limit * 2) {
        r = true;
      }
    } else if (row == 3) {
      if (i > this.menu_limit * 2 && i < this.menu_limit * 3) {
        r = true;
      }
    } else if (row == 4) {
      if (this.menu_limit * 3 <= i) {
        r = true;
      }
    }
    return r;
  }
  gotoFriends() {
    this.router.navigate(['/chats'], { queryParams: { 'show': 'friend' } });
  }
}
